@if (format === 'text') {
  <span>{{text | hisUi:params }}</span>
}
@if (format === 'html') {
  <span [innerHTML]="text | hisUi:params"></span>
}
@if (format === 'html-unsafe') {
  <span [innerHTML]="text | hisUi:params | hisHtmlUnsafe"></span>
}
@if (format === 'html-safe') {
  <span [innerHTML]="text | hisUi:params | hisHtmlSafe"></span>
}
